var DOMAINS;
(function (DOMAINS) {
    DOMAINS["DEV"] = "https://master.sravni.ru.dev.lan";
    DOMAINS["PROD"] = "https://www.sravni.ru";
})(DOMAINS || (DOMAINS = {}));

export { DOMAINS };
//# sourceMappingURL=domains.js.map
